import React from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom'
import {Link} from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
//import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
//import IntlMessages from 'util/IntlMessages';
import LogoColor from 'assets/images/logo_color.svg';
//import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import {requestPin,linkCustomer} from 'api/index';
import { loggedOut } from 'actions/Api'
import IntlMessages from 'util/IntlMessages';

class MySetup extends React.Component {
    state = {
        activeStep: 0,  // 0=customer/zip   1=code
        email: '',
        zip: '',
        pin: '',
        customer: '',
        showErrors: false
    };

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps !== this.props) {
            if (this.props.requestPinFailed) {
                this.setState({activeStep: 0});
            }
            if (this.props.linkCustomerFailed) {
                this.setState({activeStep: 1});
            }
            if (this.props.verification) {
                this.setState({activeStep: 1});
            }
        }
    }

    handleReset = () => {
        this.setState({
            activeStep: 0,
            email: '',
            zip: '',
            pin: '',
            customer: '',
            showErrors: false
        });
    };

    handleNext = () => {
        if (this.state.activeStep===0) {
            // first check if customer number and zip COULD be valid
            if (!this.isValidZip() || !this.isValidCustomer()) {
                // NO, so don't even try but jump back to step 1 with error message shown
                this.setState({activeStep: 0, showErrors: true});
            } else {
                // YES, could be valid, so ask for customer number and request pin
                if (this.state.customer.match(/^\d{3,4}$/)) {
                    // if customer number is shorter than 6 digits (old customer number), multiply by 10 and add 100000
                    this.props.dispatch(requestPin(this.props.apiUrl,this.props.session,{ customer: (parseInt(this.state.customer)*10+100000), zip: this.state.zip }));
                } else {
                    this.props.dispatch(requestPin(this.props.apiUrl,this.props.session,{ customer: this.state.customer, zip: this.state.zip }));
                }
            }
        }
        if (this.state.activeStep>0) {
            // YES, could be valid, so try to verify code (i.e. connect account to customer number)
            this.props.dispatch(linkCustomer(this.props.apiUrl,this.props.session,{ code: this.state.pin }));
        }
    };

    handleBack = () => {
        this.setState({activeStep: 0});
    };

    handleLogout = () => {
        this.props.dispatch(loggedOut());
    };

    handleFacebookLogin = () => {
//        console.log('MY: login via facebook');
        FB.login();
    };

    handleChange = name => event => {
        event.preventDefault();
        this.setState({
            [name]: event.target.value,
        },()=>{
//            console.log(event);
        });
    };

    handleInputKeyDown = (e) => {
        if (e.keyCode === 13) {
            if (typeof e.preventDefault === "function") {
                e.preventDefault();
            }
            this.handleNext();
//            this.refs[this.fieldOrder[e.target.name]].focus();
        }
    };
    
    isValidCustomer = () => {
        return this.state.customer.match(/^\d{3,6}$/);
    };

    isValidZip = () => {
        return this.state.zip.match(/^\d{5,5}$/);
    };
    
    render() {
        const steps = 2;
        const {activeStep} = this.state;
        return (
            <div className="app-main-container">
                <main className="app-main-content-wrapper">
                    <div className="app-main-content">
                        <div className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                            <div className="login-content">
                                <div className="login-header mb-4">
                                    <Link className="app-logo" to="/" title="Jambo">
                                        <img src={LogoColor} alt="jambo" title="jambo"/>
                                    </Link>
                                </div>

                                <div className="login-form">
                                    {
                                        <form>
                                            <fieldset>
                                                {
                                                    this.state.activeStep === 0 &&
                                                    <div>
                                                        {
                                                            this.props.requestPinFailed &&
                                                            <div style={{color: 'red', marginBottom: '10px'}}>
                                                                <IntlMessages id="components.MySetup.notFound"/>
                                                            </div>
                                                        }
                                                        <div>
                                                           <IntlMessages id="components.MySetup.toConnect"/>
                                                        </div>
                                                        <TextField
                                                            id="customer"
                                                            label={<IntlMessages id="components.MySetup.customerNumber"/>}
                                                            autoFocus
                                                            fullWidth
//                                                            onChange={(event) => this.setState({customer: event.target.value})}
                                                            onChange={this.handleChange('customer')}
                                                            onKeyDown={this.handleInputKeyDown}
                                                            defaultValue={this.state.customer}
                                                            margin="normal"
                                                            className="mt-1"
                                                            error={!this.isValidCustomer() && this.state.showErrors}
                                                            helperText={!this.isValidCustomer() && this.state.showErrors && <IntlMessages id="components.MyLogin.customerHelper"/>}                            
                                                        />
                                                        <TextField
                                                            id="zip"
                                                            label={<IntlMessages id="components.MySetup.zip"/>}
                                                            fullWidth
//                                                            onChange={(event) => this.setState({zip: event.target.value})}
                                                            onChange={this.handleChange('zip')}
                                                            onKeyDown={this.handleInputKeyDown}
                                                            defaultValue={this.state.zip}
                                                            margin="normal"
                                                            className="mt-1"
                                                            error={!this.isValidZip() && this.state.showErrors}
                                                            helperText={!this.isValidZip() && this.state.showErrors && <IntlMessages id="components.MyLogin.zipHelper"/>}                            
                                                        />
                                                    </div>
                                                }
                                                <div>
                                                    {
                                                        this.state.activeStep > 0 && this.props.linkCustomerFailed &&
                                                        <div style={{color: 'red', marginBottom: '10px'}}>
                                                            <IntlMessages id="components.MySetup.wrongCode"/>
                                                        </div>
                                                    }
                                                    {
                                                        this.state.activeStep > 0 && this.props.verification &&
                                                        <div>
                                                            <IntlMessages id="components.MySetup.pinSent"/>
                                                            <br/>
                                                            { this.props.verification.verificationMobile && <span><IntlMessages id="components.MySetup.viaSms" values={{to: this.props.verification.verificationMobile}}/><br/></span>}
                                                            { this.props.verification.verificationEmail && <span><IntlMessages id="components.MySetup.viaEmail" values={{to: this.props.verification.verificationEmail}}/><br/></span> }
                                                            { this.props.verification.verificationPost && <span><IntlMessages id="components.MySetup.viaPost" values={{to: this.props.verification.verificationPost}}/><br/></span> }
                                                            <br/>
                                                            <IntlMessages id="components.MySetup.enterCode"/>
                                                        </div>
                                                    }
                                                    {
                                                        this.state.activeStep > 0 &&
                                                        <TextField
                                                            type="code"
                                                            id="code"
                                                            label={<IntlMessages id="components.MySetup.code"/>}
                                                            autoFocus
                                                            fullWidth
                                                            defaultValue={this.state.pin}
//                                                            onChange={(event) => this.setState({pin: event.target.value})}
                                                            onChange={this.handleChange('pin')}
                                                            onKeyDown={this.handleInputKeyDown}
                                                            margin="normal"
                                                            className="mt-1"
                                                            autoComplete="one-time-code"
                                                        />
                                                    }
                                                </div>

                                                <div className="d-flex justify-content-center" style={{marginTop: '15px'}}>
                                                    {
                                                        this.state.activeStep > 0 &&
                                                        <Button variant="raised" className="jr-btn text-white bg-grey" onClick={this.handleBack}>
                                                            <IntlMessages id="components.MySetup.back"/>
                                                        </Button>
                                                    }
                                                    {
                                                        this.state.activeStep === 0 &&
                                                        <Button variant="raised" className="jr-btn text-white bg-grey" onClick={this.handleLogout}>
                                                            <IntlMessages id="components.MySetup.abort"/>
                                                        </Button>
                                                    }
                                                    <Button variant="raised" className="jr-btn text-white bg-secondary" onClick={this.handleNext}>
                                                        <IntlMessages id="components.MySetup.next"/>
                                                    </Button>
                                                </div>

                                            </fieldset>
                                        </form>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        apiUrl: state.api.url,
        session: state.api.session,
        emailExists: state.api.emailExists,
        loginFailure: state.api.loginFailure,
        verification: state.profile && state.profile.verification,
        requestPinFailed: state.profile && state.profile.requestPinFailed,
        linkCustomerFailed: state.profile && state.profile.linkCustomerFailed,
    }
}

export default withRouter(connect(mapStateToProps)(MySetup));
